<template>
    <div id="PaymentForm" class="form_style">
        <template v-if="bypass_payment">
            <h2>Place Order</h2>
        </template>
        <template v-else>
            <h2>Payment</h2>
        </template>
        <div class="wrapper">
            <template v-if="enabled_payment_methods > 1 && !bypass_payment">
                <h3>Select a payment method</h3>
                <div class="grid">
                    <p class="fancy_radio_button" v-if="on_hold_enabled">
                        <input type="radio" name="payment_type" id="payment_type_4" value="on_hold"
                            v-model="payment_method">
                        <label for="payment_type_4">
                            <i class="fal fa-clock"></i>
                            <span><b>On Hold</b></span>
                            <span>Submit order and place on hold until payment has been confirmed. No emails will be sent, and no details uploaded to logistics providers.</span>
                        </label>
                    </p>
                    <p class="fancy_radio_button" v-if="stripe_enabled && !stripe_disabled">
                        <input type="radio" name="payment_type" id="payment_type_1" value="stripe"
                            v-model="payment_method">
                        <label for="payment_type_1">
                            <i class="fal fa-credit-card"></i>
                            <span><b>Credit/Debit Card</b></span>
                            <span>Pay using your credit or debit card using our payment provider Stripe.</span>
                        </label>
                    </p>
                    <p class="fancy_radio_button" v-if="paypal_enabled">
                        <input type="radio" name="payment_type" id="payment_type_2" value="paypal"
                            v-model="payment_method">
                        <label for="payment_type_2">
                            <i class="fab fa-paypal"></i>
                            <span><b>PayPal</b></span>
                            <span>Pay using your Paypal account.
                                <template v-if="total >= 30">
                                    Option to pay later is available
                                </template>
                            </span>
                        </label>
                    </p>
                    <p class="fancy_radio_button" v-if="pay_on_account_enabled">
                        <input type="radio" name="payment_type" id="payment_type_3" value="account"
                            v-model="payment_method">
                        <label for="payment_type_3">
                            <i class="fal fa-folder-open"></i>
                            <span><b>On Trade Account</b></span>
                            <span>Pay on account and we'll invoice you.</span>
                        </label>
                    </p>
                </div>
            </template>
            <div v-show="payment_method == 'stripe'" class="form_style">
                <div id="express-checkout-element"></div>
                <div class="stripe-express-checkout-divide" v-if="showCheckoutDivide">Or Pay Using</div>
                <div id="payment-element"></div>
            </div>
                <div class="terms_box" v-html="terms"></div>
                <p class="styled_checkboxes">
                    <input type="checkbox" name="agree" id="agree" value="1" v-model="agree">
                    <label for="agree"><span>I agree with the <a href="/terms-and-conditions-for-the-sale-of-products"
                                target="_blank">Terms of Use</a></span></label>
                </p>
                <template v-if="payment_method">
                <p class="styled_checkboxes" v-if="!has_consent">
                    <input type="checkbox" name="opt_in" id="opt_in" value="1" v-model="opt_in">
                    <label for="opt_in"><span>If you wish to receive news and offers from Stone & Surfaces Direct via
                            email,
                            please tick this box.</span></label>
                </p>
                <p class="styled_checkboxes" v-if="kerbside_option">
                    <input type="checkbox" name="kerbside" id="kerbside" value="1" v-model="kerbside">
                    <label for="kerbside">
                        <span>
                            <strong>I understand delivery is kerbside, and a hydraulic pallet truck is used
                            to move the consignment onto my property.
                            <br>(Our delivery partner, Pallet Track will make every effort to move the pallet as close to your house as possible.)
                            <br>View our <a href="/kerbside-delivery-info.pdf" target="_blank">delivery pdf</a> for more details.</strong>
                        </span>
                    </label>
                </p>
                <template v-if="payment_method == 'paypal'">
                    <paypal-component
                        :total="Number(total)"
                        :submittable="submittable"
                        :agreeTerms="agree"
                        :kerbsideOption="kerbside_option"
                        :kerbside="kerbside"
                    />
                </template>
                <p v-if="payment_method != 'paypal'">
                    <button id="proceed_button" class="button wide upper green arrow"
                        :disabled="!submittable || !agree || (kerbside_option && !kerbside)"
                        @click.prevent="placeOrder">Place Order</button>
                </p>
            </template>
        </div>
    </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
export default {
    props: {
        billing_address: {
            type: [Array, Object],
            default: () => ({}),
            required: false,
        },
        bypass_payment: {
            type: Boolean,
            default: () => false,
            required: false,
        },
        has_consent: {
            type: Boolean,
            default: () => false,
            required: false,
        },
        terms: {
            type: String,
            default: () => "",
            required: false,
        },
        stripe_enabled: {
            type: Boolean,
            default: () => false,
            required: false,
        },
        stripe_key: {
            type: String,
            default: () => '',
            required: false,
        },
        paypal_enabled: {
            type: Boolean,
            default: () => false,
            required: false,
        },
        pay_on_account_enabled: {
            type: Boolean,
            default: () => false,
            required: false,
        },
        on_hold_enabled: {
            type: Boolean,
            default: () => false,
            required: false,
        },
        total: {
            type: String,
            default: () => '',
            required: true,
        },
        kerbside_option: {
            type: Boolean,
            default: () => false,
            required: true,
        },
    },
    data() {
        return {
            stripe_initialised: false,
            stripe_disabled: false,
            showCheckoutDivide: false,
            messages: '',
            submittable: true,
            agree: false,
            opt_in: false,
            kerbside: false,
            clientSecret: '',
            payment_method: '',
            stripe: {},
            stripeElements: {},
            appearance: {
                theme: 'stripe',
                variables: {
                    borderRadius: '1px',
                    colorBackground: '#fdfdfd'
                },
                rules: {
                    '.Input': {
                        border: '1px solid #E0E6EB',
                        boxShadow: '0px',
                    },
                }
            },
            options: {
                fields: {
                    billingDetails: {
                        address: {
                            postalCode: 'never'
                        }
                    }
                },
                layout: {
                    type: 'tabs',
                    defaultCollapsed: false,
                }
            },
        };
    },
    computed: {
        enabled_payment_methods: function () {
            var count = this.stripe_enabled + this.paypal_enabled + this.pay_on_account_enabled + this.on_hold_enabled;
            return count;
        },
        billingDetails() {
            return {
                name: this.billing_address.first_name + ' ' + this.billing_address.last_name,
                email: this.billing_address.email,
                phone: this.billing_address.telephone,
                address: {
                    line1: this.billing_address.address_1,
                    line2: this.billing_address.address_2,
                    city: this.billing_address.town,
                    state: this.billing_address.county,
                    postal_code: this.billing_address.postcode
                }
            }
        }

    },
    mounted() {
        if (this.stripe_enabled && !this.bypass_payment) this.generatePaymentIntent();
        if (this.enabled_payment_methods == 1) {
            if (this.stripe_enabled) {
                this.payment_method = 'stripe';
            } else if (this.paypal_enabled) {
                this.payment_method = 'paypal';
            } else if (this.pay_on_account_enabled) {
                this.payment_method = 'account';
            } else if (this.on_hold_enabled) {
                this.payment_method = 'on_hold';
            }
        }
        if (this.bypass_payment) this.payment_method = 'no-charge';
    },
    methods: {
        ...mapActions(["addAlert"]),
        createStripeInstance() {
            this.stripe = Stripe(this.stripe_key);
            const appearance = this.appearance;
            const options = this.options;
            const clientSecret = this.clientSecret;
            this.stripeElements = this.stripe.elements({
                clientSecret,
                appearance
            });
            const expressCheckoutElement = this.stripeElements.create("expressCheckout");
            expressCheckoutElement.mount("#express-checkout-element");

            const paymentElement = this.stripeElements.create('payment', options);
            paymentElement.mount('#payment-element');
            this.stripe_initialised = true;
            this.setupExpressCheckoutConfirmListener(expressCheckoutElement);
        },
        setupExpressCheckoutConfirmListener(expressCheckoutElement) {
            expressCheckoutElement.on('ready', (event) => {
                if (event.availablePaymentMethods) {
                    if (event.availablePaymentMethods.applePay || event.availablePaymentMethods.googlePay) {
                        this.showCheckoutDivide = true;
                    }
                }
            });
            expressCheckoutElement.on("confirm", async (event) => {
                this.placeOrder();
            });
        },
        async checkOrderValidity() {
            axios.post('/ajax/checkOrderValidity').then((response) => {
                if (response.data.valid == false) {
                    alert(response.data.message);
                    this.payment_method = "";
                    window.location.href = '/basket';
                    return false;
                } else {
                    return true;
                }
            }).catch(error => {
                window.location.href = '/basket';
            });
        },
        async generatePaymentIntent() {
            try {
                const response = await axios.post('/checkout/payment/payment-intent');
                this.clientSecret = response.data;
                this.createStripeInstance();
            } catch (error) {
                this.stripe_disabled = true;
                window.location.href = '/basket';
                console.error('Error generating payment intent:', error);
            }
        },
        async placeOrder() {
            this.submittable = false;
            if (this.checkOrderValidity()) {
                $('#proceed_button').removeClass('arrow').addClass('spinner');
                if (this.payment_method == 'no-charge') {

                    axios.post('/checkout/payment/no-charge', {
                        opt_in: this.opt_in
                    }).then(
                        response => {
                            console.log(response.data);
                            window.location.replace(response.data);
                        });
                }

                if (this.payment_method == 'on_hold') {

                    axios.post('/checkout/payment/on-hold', {
                        opt_in: this.opt_in
                    }).then(
                        response => {
                            console.log(response.data);
                            window.location.replace(response.data);
                    });
                }

                if (this.payment_method == 'stripe') {
                    const elements = this.stripeElements;
                    const {
                        error,
                        paymentIntent
                    } = await this.stripe.confirmPayment({
                        elements,
                        confirmParams: {
                            payment_method_data: {
                                billing_details: this.billingDetails
                            }
                        },
                        redirect: "if_required"
                    });

                    if (paymentIntent && paymentIntent.status === "succeeded") {
                        // Post success response to Laravel
                        await axios.post('/checkout/payment/confirm', {
                            payment_intent_id: paymentIntent.id,
                            opt_in: this.opt_in
                        }).then(response => {
                            window.location.href = response.data.redirect_url;
                        }).catch(error => {
                            this.messages = error.message;
                            this.addAlert({
                                alertClass: 'alert-danger',
                                alertMessage: '<strong>Error</strong> ' + this.messages,
                                alertImportant: true,
                            });
                        });
                    }

                    if (error) {
                        this.submittable = true;
                        $('#proceed_button').removeClass('spinner').addClass('arrow');
                        if (error.type === "card_error" || error.type === "validation_error") {
                            this.messages = error.message;
                        } else {
                            this.messages = "An unexpected error occured.";
                        }
                        this.addAlert({
                            alertClass: 'alert-danger',
                            alertMessage: '<strong>Error</strong> ' + this.messages,
                            alertImportant: true,
                        });
                    }
                }
            }
        },
    },
};

</script>

<style>
.stripe-express-checkout-divide {
    font-size: 1.4rem;
    font-weight: 400;
    text-align: center;
    text-transform: uppercase;
    white-space: nowrap;
    width: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 2em 0;
    font-weight: 600;
    color: #626262;
}

.stripe-express-checkout-divide::before,
.stripe-express-checkout-divide::after {
    background-color: #dadada;
    content: "";
    flex-grow: 1;
    height: 1px;
}

.stripe-express-checkout-divide::before {
    display: block;
    margin-right: 1.5%;
    width: 50%;
}

.stripe-express-checkout-divide::after {
    display: block;
    margin-left: 1.5%;
    width: 50%;
}
</style>
